import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSiteSettings } from "../contexts/SiteSettingsContext";

const useFrontendMeta = (overridePath) => {
  const { pathname } = useLocation();
  const path = overridePath ?? pathname;
  const { website = {}, contact = null, page_meta = [], social_links = [] } = useSiteSettings();

  return useMemo(() => {
    const pageKey = path.replace(/^\//, "").split("/")[0] || "home";
    const meta =
      page_meta.find((m) => m.page_name === pageKey && m.status && !m.deleted_at) ||
      page_meta.find((m) => m.page_name === "default" && m.status && !m.deleted_at);
    const companyName = website.website_name || "Directorate Of MD&EHS Rehabilitation Department Government Of Sindh";
    return {
      companyName,
      whatsappNumber: process.env.REACT_APP_WHATSAPP_NUMBER || null,
      title: meta?.meta_title || companyName,
      description: meta?.meta_description || companyName,
      keywords: meta?.meta_keywords || null,
      og_tags: meta?.og_tags || {},
      canonical_links: meta?.canonical_links || [],
      footer: {
        description: website.footer_about || null,
        logo: website.header_logo || null,
        socialLinks: social_links || [],
        contact: contact || null,
      },
    };
  }, [path, website, contact, page_meta, social_links]);
};

export default useFrontendMeta;
